import { useStrictLocalization } from "@faire/localization/react/useStrictLocalization";
import { EyeClosed } from "@faire/slate-icons/EyeClosed";
import { EyeOpen } from "@faire/slate-icons/EyeOpen";
import { FormFieldIconButton } from "@faire/slate/private/form/FormFieldIconButton";
import React from "react";

type IProps = {
  isPlainText: boolean;
  onClick?: (e: React.MouseEvent) => void;
};

export const PasswordModeButton: React.FC<IProps> = ({
  isPlainText,
  onClick,
}) => {
  const { strictLocalize } = useStrictLocalization();
  return (
    <FormFieldIconButton
      Icon={isPlainText ? EyeClosed : EyeOpen}
      onClick={onClick}
      aria-label={
        isPlainText
          ? strictLocalize({
              id: "B0RCm/",
              defaultMessage: "Hide password",
              description: {
                text: "Label for button to conceal password in a password input",
              },
            })
          : strictLocalize({
              id: "Ut9/kn",
              defaultMessage: "Show password",
              description: {
                text: "Label for button to reveal password in a password input",
              },
            })
      }
    />
  );
};
